// Tony & Charlie — "Complete the look" in de winkelwagen-lade.
// 27-10: BABY-REGEL (keuze Michael). Ligt er een babyproduct in de wagen, dan toont het blok
// altijd de Fluffy Bear Booties (Cream). Babyproduct = product met tag "Baby" en een gekozen maat
// t/m 80 (of zonder maat, zoals de wantjes). De slofjesmaat volgt de maat in de wagen:
// t/m 68 → 0-6 months, t/m 80 → 7-12 months. Ligt er al een paar slofjes in de wagen, dan geldt
// de gewone regel hieronder.
// Gewone regel (keuze Michael 08-10): vaste suggestie Bear Loungewear in Grey, met de maat van het
// laatst toegevoegde product alvast geselecteerd als die bestaat.
// Ligt Bear Loungewear al in de wagen, of is Grey in alle maten uitverkocht, dan valt het blok
// terug op Shopify-aanbevelingen (eerst "complementary" uit Search & Discovery, anders "related"):
// 2 stuks, liefst een ander soort item (jas → broek) en niets wat al in de wagen ligt.
// 19-10: maten volgen dezelfde voorraadgrens als de productpagina ("sold out" onder 6 stuks).
// De voorraad komt uit window.TCUpsellStock (snippets/tc-upsell-stock.liquid).
(function () {
  // Wijzigen = alleen deze waarden aanpassen (handle uit de product-URL, kleurnaam zoals in Shopify).
  // Pas bij een andere handle ook de handle in snippets/tc-upsell-stock.liquid aan.
  var FIXED = { handle: 'bear-loungewear', colour: 'Grey' };
  var BABY = {
    handle: 'fluffy-bear-booties',
    colour: 'Cream',
    tag: 'baby',          // tag (hoofdletters maken niet uit)
    maxSize: 80,          // grootste maat (cm) die nog als baby telt
    // Ligt een van deze al in de wagen, dan geen slofjes voorstellen:
    skip: ['fluffy-bear-booties', 'bear-print-booties', 'peekaboo-bear-booties']
  };

  var cache = {};
  var fixedCache = {};
  var tagCache = {};
  var renderToken = 0;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents, currency) {
    try {
      return (cents / 100).toLocaleString('nl-NL', { style: 'currency', currency: currency || 'EUR' });
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + (currency || '');
    }
  }

  // Te bestellen = beschikbaar én (als de voorraad bekend is) niet onder de grens van de productpagina.
  function buyable(v) {
    if (!v || !v.available) { return false; }
    var s = window.TCUpsellStock;
    if (!s || !s.qty) { return true; }
    var q = s.qty[String(v.id)];
    if (q === null || q === undefined) { return true; }
    return q >= (s.soldoutBelow || 0);
  }

  function nums(s) { return String(s || '').match(/\d+/g) || []; }

  function sizeOf(item) {
    var out = '';
    (item.options_with_values || []).forEach(function (o) {
      if (/size|maat/i.test(o.name)) { out = o.value; }
    });
    return out;
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function recs(productId) {
    if (cache[productId]) { return cache[productId]; }
    function get(intent) {
      return fetch(root() + 'recommendations/products.json?product_id=' + productId + '&limit=10&intent=' + intent)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; });
    }
    cache[productId] = Promise.all([get('complementary'), get('related')])
      .then(function (a) { return a[0].concat(a[1]); });
    return cache[productId];
  }

  function optionIndex(p, re) {
    var idx = -1;
    (p.options || []).forEach(function (o, i) {
      var name = typeof o === 'string' ? o : o.name;
      if (re.test(name)) { idx = i; }
    });
    return idx;
  }

  function sizeIndex(p) { return optionIndex(p, /size|maat/i); }

  // Een vaste suggestie: alleen de varianten in de gekozen kleur, met de foto van die kleur.
  function fixedProduct(cfg) {
    if (fixedCache[cfg.handle]) { return fixedCache[cfg.handle]; }
    fixedCache[cfg.handle] = fetch(root() + 'products/' + cfg.handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) { return null; }
        var ci = optionIndex(p, /colou?r|kleur/i);
        var want = cfg.colour.toLowerCase();
        var vs = p.variants.filter(function (v) {
          return ci > -1 && String(v.options[ci]).toLowerCase() === want;
        });
        var avail = vs.filter(buyable);
        if (!avail.length) { return null; }
        var first = avail[0];
        var img = (first.featured_image && first.featured_image.src) || p.featured_image || '';
        var base = p.url || (root() + 'products/' + p.handle);
        return {
          id: p.id,
          title: p.title,
          subtitle: vs[0].options[ci],
          url: base + (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + first.id,
          featured_image: img,
          price: first.price,
          options: p.options,
          variants: vs,
          available: true,
          type: p.type
        };
      })
      .catch(function () { return null; });
    return fixedCache[cfg.handle];
  }

  // Tags van een product in de wagen (de winkelwagen zelf geeft geen tags mee).
  function tagsOf(handle) {
    if (tagCache[handle]) { return tagCache[handle]; }
    tagCache[handle] = fetch(root() + 'products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var t = (p && p.tags) || [];
        if (typeof t === 'string') { t = t.split(','); }
        return t.map(function (x) { return String(x).trim().toLowerCase(); });
      })
      .catch(function () { return []; });
    return tagCache[handle];
  }

  // Eerste babyproduct in de wagen (nieuwste eerst), of null.
  function babyItem(cart) {
    var hasSkip = cart.items.some(function (i) { return BABY.skip.indexOf(i.handle) > -1; });
    if (hasSkip) { return Promise.resolve(null); }
    var candidates = cart.items.filter(function (i) {
      var s = sizeOf(i);
      var n = nums(s);
      return !s || !n.length || parseInt(n[0], 10) <= BABY.maxSize;
    });
    if (!candidates.length) { return Promise.resolve(null); }
    return Promise.all(candidates.map(function (i) { return tagsOf(i.handle); }))
      .then(function (lists) {
        for (var k = 0; k < candidates.length; k++) {
          if (lists[k].indexOf(BABY.tag) > -1) { return candidates[k]; }
        }
        return null;
      });
  }

  // Maat in de wagen → maat van de slofjes (zoals de keuzelijst ze toont).
  function bootieSize(size) {
    var n = nums(size);
    if (!n.length) { return ''; }
    var cm = parseInt(n[0], 10);
    if (cm <= 68) { return '0-6 months'; }
    if (cm <= BABY.maxSize) { return '7-12 months'; }
    return '';
  }

  function matchVariant(p, size) {
    if (!size) { return null; }
    var want = nums(size);
    var si = sizeIndex(p);
    var found = null;
    p.variants.forEach(function (v) {
      if (found || !buyable(v)) { return; }
      var val = si > -1 ? v.options[si] : v.title;
      if (nums(val).some(function (n) { return want.indexOf(n) > -1; })) { found = v; }
    });
    return found;
  }

  function variantLabel(p, v) {
    if (!v.title || v.title === 'Default Title') { return 'One size'; }
    var colours = {};
    p.variants.forEach(function (x) { if (buyable(x)) { colours[x.options[0]] = 1; } });
    var si = sizeIndex(p);
    if (Object.keys(colours).length <= 1 && si > -1) { return 'Size ' + v.options[si]; }
    return v.title;
  }

  function priceHtml(cents, currency) {
    var sale = window.TCSale;
    if (sale && sale.isActive && sale.isActive()) {
      return '<span class="cd-up__was">' + esc(money(cents, currency)) + '</span> ' + esc(money(sale.salePrice(cents), currency));
    }
    return esc(money(cents, currency));
  }

  function card(p, size, currency) {
    var avail = p.variants.filter(buyable);
    var pre = matchVariant(p, size);
    if (!pre && avail.length === 1) { pre = avail[0]; }
    var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
    if (img.indexOf('//') === 0) { img = 'https:' + img; }
    var opts = (pre ? '' : '<option value="" selected disabled>Choose size</option>') + avail.map(function (v) {
      return '<option value="' + v.id + '" data-price="' + v.price + '"' + (pre && pre.id === v.id ? ' selected' : '') + '>' + esc(variantLabel(p, v)) + '</option>';
    }).join('');
    var shownPrice = pre ? pre.price : p.price;
    return '<div class="cd-up" data-up>' +
      '<a class="cd-up__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</a>' +
      '<div class="cd-up__body">' +
        '<a class="cd-up__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        (p.subtitle ? '<span class="cd-up__meta">' + esc(p.subtitle) + '</span>' : '') +
        '<div class="cd-up__price" data-up-price data-currency="' + esc(currency) + '">' + priceHtml(shownPrice, currency) + '</div>' +
        '<div class="cd-up__row">' +
          '<select class="cd-up__select" data-up-variant aria-label="Size for ' + esc(p.title) + '">' + opts + '</select>' +
          '<button type="button" class="cd-up__add" data-up-add>Add</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function autoPicks(source, inCart, size) {
    return recs(source.product_id).then(function (list) {
      var seen = {};
      var pool = list.filter(function (p) {
        if (seen[p.id] || inCart[p.id] || !p.available) { return false; }
        seen[p.id] = 1;
        return true;
      });
      // Volgorde: eerst stuks in dezelfde maat, dan liefst een ander soort item (jas → broek)
      var srcType = (source.product_type || '').toLowerCase();
      function score(p) {
        return (matchVariant(p, size) ? 2 : 0) + ((p.type || '').toLowerCase() !== srcType ? 1 : 0);
      }
      var ranked = pool.map(function (p, i) { return { p: p, s: score(p), i: i }; });
      ranked.sort(function (a, b) { return (b.s - a.s) || (a.i - b.i); });
      return ranked.slice(0, 2).map(function (x) { return x.p; });
    });
  }

  function render(cart, container) {
    var token = ++renderToken;
    var old = container.querySelector('.cd-upsell');
    if (old) { old.remove(); }
    if (!cart || !cart.item_count) { return; }
    var source = cart.items[0];
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
    var size = sizeOf(source);

    babyItem(cart).then(function (baby) {
      if (!baby) { return null; }
      return fixedProduct(BABY).then(function (booties) {
        if (!booties || inCart[booties.id]) { return null; }
        return { picks: [booties], size: bootieSize(sizeOf(baby)) };
      });
    }).then(function (babyPick) {
      if (babyPick) { return babyPick; }
      return fixedProduct(FIXED).then(function (fixed) {
        if (fixed && !inCart[fixed.id]) { return { picks: [fixed], size: size }; }
        return autoPicks(source, inCart, size).then(function (p) { return { picks: p, size: size }; });
      });
    }).then(function (res) {
      if (token !== renderToken || !res || !res.picks || !res.picks.length) { return; }
      var box = document.createElement('div');
      box.className = 'cd-upsell';
      box.innerHTML = '<p class="cd-upsell__title">Complete the look</p>' +
        res.picks.map(function (p) { return card(p, res.size, cart.currency); }).join('');
      var prev = container.querySelector('.cd-upsell');
      if (prev) { prev.remove(); }
      container.appendChild(box);
    });
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-up-variant]');
    if (!sel) { return; }
    var opt = sel.options[sel.selectedIndex];
    var priceEl = sel.closest('[data-up]').querySelector('[data-up-price]');
    if (opt && opt.getAttribute('data-price') && priceEl) {
      priceEl.innerHTML = priceHtml(parseInt(opt.getAttribute('data-price'), 10), priceEl.getAttribute('data-currency'));
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-up-add]');
    if (!btn) { return; }
    var wrap = btn.closest('[data-up]');
    var sel = wrap.querySelector('[data-up-variant]');
    if (!sel.value) { sel.classList.add('is-missing'); sel.focus(); return; }
    sel.classList.remove('is-missing');
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var title = (wrap.querySelector('.cd-up__title') || {}).textContent || 'Item';
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(sel.value, 10), quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, j: j }; });
    }).then(function (res) {
      document.dispatchEvent(new CustomEvent('tc:cart-changed', {
        detail: res.ok ? { message: '✓ ' + title + ' was added to your cart' } : { message: res.j.description || res.j.message || 'Sorry, this item could not be added.', error: true }
      }));
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Add';
    });
  });

  window.TCUpsell = { render: render };
})();
